import Constants from "../../../../constants/constants.js";

export default {
    inputs: [
        {
            name: "first_name",
            label: "First Name",
            type: "text",
            required: true,
            wide: true,
            inline: true,
            centered: true,
            validation: function (value) {
                if (value === "") {
                    return {
                        valid: false,
                        message: "First Name is required"
                    }
                }
                else if (value.length < 2) {
                    return {
                        valid: false,
                        message: "First Name must be at least 2 letters long"
                    }
                }
                else {
                    return {
                        valid: true
                    }
                }
            }
        },
        {
            name: "last_name",
            label: "Last Name",
            type: "text",
            required: true,
            wide: true,
            inline: true,
            centered: true,
            validation: function (value) {
                if (value === "") {
                    return {
                        valid: false,
                        message: "Last Name is required"
                    }
                }
                else if (value.length < 2) {
                    return {
                        valid: false,
                        message: "Last Name must be at least 2 letters long"
                    }
                }
                else {
                    return {
                        valid: true
                    }
                }
            }
        },
        {
            name: "email",
            label: "Email",
            type: "email",
            required: true,
            wide: true,
            inline: true,
            centered: true
        },
        {
            name: "role",
            label: "Role",
            type: "select",
            options: [
            ],
            required: true,
            wide: true,
            inline: true,
            centered: true
        },
        {
            name: "organizations",
            label: "Facility",
            type: "select",
            options: [
            ],
            required: true,
            wide: true,
            inline: true,
            centered: true,
            multiple: true
        },
        {
            name: "password",
            label: "Password",
            type: "password",
            required: true,
            wide: true,
            inline: true,
            centered: true,
            require_strong: true
        },
        {
            parent_field: "role",
            active_values: [Constants.BUSINESS_GROUP_ADMIN_ROLE_LEVEL, Constants.REGIONAL_ADMIN_ROLE_LEVEL],
            name: "send_usage_email",
            label: "Send Usage Data Email",
            type: "checkbox",
            required: false
        }
    ],
    submit: {
        centered: true
    }
}


// WEBPACK FOOTER //
// ./src/components/containers/manager-dashboard/manage-personnel/personnel-form-config.js